import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useReportsStore = defineStore('reports', {
  state,
  getters,
  actions
})

export default useReportsStore
